<template>
    <section class="c-o-section-featured">
        <div class="c-o-section-featured__inner">
            <div class="c-o-section-featured__headline">
                <h2 class="c-o-section-featured__title">
                    Utvalda förfrågningar<span
                        v-if="
                            !isLoading &&
                                !error &&
                                featuredRequests &&
                                closestRegion
                        "
                    >
                        i {{ closestRegion.Name }}</span
                    >
                </h2>
            </div>
            <div class="c-o-section-featured__content">
                <div class="o-grid o-grid--25-25-25-25">
                    <div
                        class="o-grid__block"
                        v-for="(item, key) in requests"
                        :key="`featured-request-${key}`"
                    >
                        <card :request="item"></card>
                    </div>
                </div>
            </div>
            <div class="c-o-section-featured__footer">
                <button-link
                    class="c-a-button--theme-primary "
                    :label="'Se alla förfrågningar'"
                    :link="'sok-forfragan'"
                ></button-link>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    FETCH_REQUESTS,
    GET_ERROR,
    GET_REQUESTS,
    IS_LOADING
} from "../../../../store/store-models/featured-requests-model";
import {
    FETCH_CLOSEST_REGION,
    FETCH_FILTERS,
    GET_CLOSEST_REGION,
    GET_REGIONS
} from "../../../../store/store-models/filters-model";

import ButtonLink from "../../atoms/AtomButtonLink.vue";
import Icon from "../../atoms/AtomIcon.vue";
import Card from "../../molecules/MoleculeCardRequest.vue";

export default {
    props: ["content", "data"],
    components: {
        ButtonLink,
        Icon,
        Card
    },
    computed: {
        ...mapGetters({
            regions: GET_REGIONS,
            closestRegion: GET_CLOSEST_REGION,
            featuredRequests: GET_REQUESTS,
            isLoading: IS_LOADING,
            error: GET_ERROR
        }),
        requests: {
            get() {
                return this.featuredRequests && this.featuredRequests.length > 0
                    ? this.featuredRequests
                    : this.data.data;
            }
        }
    },
    methods: {
        ...mapActions({
            fetchFilters: FETCH_FILTERS,
            fetchClosestRegion: FETCH_CLOSEST_REGION,
            fetchRequests: FETCH_REQUESTS
        }),
        getGeolocation() {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    // Success
                    async position => {
                        // Mappa koordinater mot lista över tillgängliga regioner, hitta närmaste och hämta relevant data från .NET
                        const coords = {
                            lng: position.coords.longitude,
                            lat: position.coords.latitude
                        };
                        await this.fetchClosestRegion(coords);
                        this.fetchRequests(this.closestRegion.Id);
                    },
                    // Failure
                    err => {
                        console.warn("position not found", err);
                    },
                    // Options
                    {
                        timeout: 10000
                    }
                );
            }
        }
    },
    async created() {
        await this.fetchFilters();
    },
    mounted() {
        this.getGeolocation();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionFeaturedRequests.vue